'use client';

import React, { Fragment, PropsWithChildren } from 'react';
import './OffCanvas.styles.scss';
import { Dialog, Transition, TransitionChild } from '@headlessui/react';
import classNames from 'classnames';

export type OffCanvasProps = PropsWithChildren<{
  position?: 'left' | 'right';
  isOpen: boolean;
  handleClose: CallableFunction;
}>;

function OffCanvas({ position = 'left', isOpen, children, handleClose }: OffCanvasProps) {
  const transition = {
    left: {
      absolutePosition: 'left-0',
      start: '-translate-x-full',
      end: 'translate-x-0',
    },
    right: {
      absolutePosition: 'right-0',
      start: 'translate-x-full',
      end: 'translate-x-0',
    },
  };

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-40" onClose={() => handleClose()}>
        <TransitionChild
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" onClick={() => handleClose()} data-testid="offcanvas-backdrop" />
        </TransitionChild>

        <TransitionChild
          as="div"
          enter="transition ease-in-out duration-300 transform"
          enterFrom={transition[position].start}
          enterTo={transition[position].end}
          leave="transition ease-in-out duration-300 transform"
          leaveFrom={transition[position].end}
          leaveTo={transition[position].start}
          className={classNames(
            'absolute inset-y-0 w-full sm:w-1/2 xl:w-2/5 min-w-[300px] shadow-xl  bg-primary',
            transition[position].absolutePosition,
          )}
          data-testid="offcanvas"
        >
          {children}
        </TransitionChild>
      </Dialog>
    </Transition>
  );
}

export default OffCanvas;
